import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { Table } from '@facet-wealth/design';
import ActivateCell
  from 'Views/Page/Content/Modal/Layouts/FacetPlanProposalNextUpReview/Layout/Components/NextUpActionsDialog/DialogContent/TabContent/AccountItems/AccountItem/Layout/FundingTable/Components/ActivateCell';
import MetaControl from 'Components/UI/Meta/MetaControl';
import metaOverrideSet
  from 'Views/Page/Content/Modal/Layouts/FacetPlanProposalNextUpReview/Layout/Components/NextUpActionsDialog/DialogContent/TabContent/AccountItems/AccountItem/Layout/FundingTable/metaOverrideSet';
import PropTypes from 'prop-types';

const useStyles = buildUseStyles('FundingItemRow', ((theme) => ({
  root: {},
  tableCell: {
    display: 'table-cell',
    verticalAlign: 'inherit',
    textAlign: 'left',
    padding: theme.spacing(1),
  },
})));

const FundingItemRow = ({ resource, onChange, readonly }) => {
  const [localResource, setLocalResource] = React.useState(resource);
  const classes = useStyles();
  return (
    <Table.BodyRow key={resource.id()}>
      <Box className={classes.tableCell}>
        <ActivateCell resource={resource} onChange={onChange} readonly={readonly} />
      </Box>
      <Table.BodyCellText value={resource.attr('action')} />
      <Box className={classes.tableCell}>
        <MetaControl
          className={classes.tableCell}
          attrName="startDate"
          metaOverrideSet={metaOverrideSet}
          resource={resource}
        />
      </Box>
      <Box className={classes.tableCell}>
        <MetaControl
          className={classes.tableCell}
          attrName="endDate"
          metaOverrideSet={metaOverrideSet}
          resource={resource}
        />
      </Box>
      <Box className={classes.tableCell}>
        <MetaControl
          attrName="amountOverride"
          metaOverrideSet={metaOverrideSet}
          onChange={(value) => {
            localResource.attr('amountOverride', value);
            setLocalResource(localResource);
          }}
          onBlur={() => {
            resource.attr('amountOverride', localResource.attr('amountOverride'));
            onChange(resource);
          }}
          resource={localResource}
        />
      </Box>
    </Table.BodyRow>
  );
};

FundingItemRow.defaultProps = {
  readonly: false,
};

FundingItemRow.propTypes = {
  resource: PropTypes.object.isRequired,
  readonly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default FundingItemRow;
